<div class="container">
  <div class="modal-header">
    <div class="device-header">
      <span>
        <i class="mdi mdi-cast file-icon"></i>
        <span class="header">Discover JMEPs</span>
      </span>
      <i class="mdi mdi-close close-icon" (click)="closeModal()"></i>
    </div>
  </div>
  <div class="tabs-container">
    <mat-tab-group class="discover-tab-group" [selectedIndex]="selectedTabIndex">
      <mat-tab label="Discovery">
        <div class="loader-content" *ngIf="isLoadingProgress">
          <progress-spinner></progress-spinner>
        </div>
        <div *ngIf="!isLoadingProgress">
          <div *ngIf="!savingInProgress && !showDiscoveryResponse">
            <div class="discovery-description">
              JMEPs can be discovered by their assigned IP address. Enter a
              combination of IP address, address range or subnet to discover
              JMEPs in your network.
            </div>
            <div class="discover-content">
              <mat-card>
                <form name="discoveryForm">
                  <div class="discover-options">
                    <div class="option-items">
                      <div class="title-row">
                        <div class="label-text">IP Addresses</div>
                      </div>
                      <div class="item-text">
                        <textarea
                          rows="7"
                          cols="30"
                          name="ipAddresses"
                          [(ngModel)]="formData.ipaddress"
                          #ipAddressesInput="ngModel"
                          (ngModelChange)="onIpAddressChange()"
                          [disabled]="!hasReadWriteRole"
                        ></textarea>
                        <div class="error">
                          <mat-error>
                            <div *ngFor="let ipErrors of dataOptions.ipaddress.errorText">
                              {{ipErrors}}
                            </div>
                          </mat-error>
                        </div>
                      </div>
                    </div>

                    <div class="option-items">
                      <div class="title-row">
                        <div class="label-text">IP Address Ranges</div>
                        <div class="sublabel-text">(hyphen separated)</div>
                      </div>
                      <div class="item-text">
                        <textarea
                          rows="7"
                          cols="30"
                          name="ipAdressRanges"
                          [(ngModel)]="formData.iprange"
                          #ipAddressRangesInput="ngModel"
                          (ngModelChange)="onIpRangeChange()"
                          [disabled]="!hasReadWriteRole"
                        ></textarea>
                        <div class="error">
                          <mat-error>
                            <div *ngFor="let iprangeErrors of dataOptions.iprange.errorText">
                              {{iprangeErrors}}
                            </div>
                          </mat-error>
                        </div>
                      </div>
                    </div>

                    <div class="option-items">
                      <div class="title-row">
                        <div class="label-text">Subnet Range (CIDR)</div>
                      </div>
                      <div class="item-text">
                        <textarea
                          rows="7"
                          cols="30"
                          name="subnet"
                          [(ngModel)]="formData.subnet"
                          #subnetInput="ngModel"
                          (ngModelChange)="onSubnetChange()"
                          [disabled]="!hasReadWriteRole"
                        ></textarea>
                        <div class="error">
                          <mat-error>
                            <div *ngFor="let subnetErrors of dataOptions.subnet.errorText">
                              {{subnetErrors}}
                            </div>
                          </mat-error>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="discover-options next-row">
                    <div class="option-items large-width">
                      <div class="title-row">
                        <div class="title-text">Transmit duration</div>
                      </div>
                      <div class="item-text">
                        <input
                          type="text"
                          class="text-dec"
                          name="timeToWait"
                          [(ngModel)]="formData.timeToWait"
                          #timeToWaitInput="ngModel"
                          (ngModelChange)="onTimeToWaitChange()"
                          [disabled]="!hasReadWriteRole"
                        >
                        <span class="suffix">sec</span>
                        <div class="error">
                          <mat-error>
                            <div *ngFor="let timeToWaitErrors of dataOptions.timeToWait.errorText">
                              {{timeToWaitErrors}}
                            </div>
                          </mat-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </mat-card>
            </div>
          </div>
          <div class="actions-message" *ngIf="savingInProgress">
            <mat-spinner [diameter]="75"></mat-spinner>
            <div class="discovery-status"> Discovery in progress...
              <div *ngIf="discoveryStatusResponseMessage"
                class="discovery-status-msg">
                  {{discoveryStatusResponseMessage}}
              </div>
            </div>
          </div>
          <div class="discovery-res-container" *ngIf="!savingInProgress && showDiscoveryResponse">
            <div
              *ngIf="discoveryResponseMessage"
              class="res-title"
              [ngClass]="{'no-result': !showDiscoveyResTable }">
              {{discoveryResponseMessage}}
            </div>
            <div *ngIf="showDiscoveyResTable">
              <div class="state-container" *ngIf="discoveryStatus.length">
                <div class="discovery-state" *ngFor="let states of discoveryStatus">
                  {{states.title}}
                  <span class="count-val" [ngClass]="states.stateClass">{{states.count}}</span>
                </div>
              </div>
              <div class="discovery-table" *ngIf="discoveryTable?.columns?.length > 0">
                <viavi-table
                  [tableConfigurations]="discoveryTable"
                  [isActionEnabled]="isCheckBoxEnabled"
                  [showToolbar]="false"
                ></viavi-table>
              </div>
            </div>
            <div class="error-msg-cont" *ngIf="discoveryResponseError && discoveryResponseStatus !== 'success'">
              <div class="res-title">Error in discovering JMEPs</div>
              <div class="res-err-msg">
                {{discoveryResponseError}}
              </div>
            </div>
          </div>
          <div class="dialog-action-cont" *ngIf="!isLoadingProgress && !savingInProgress">
            <button
              mat-button mat-raised-button
              color="primary"
              *ngIf="!savingInProgress && !showDiscoveryResponse"
              [disabled]="!isValidAddress() || !hasReadWriteRole"
              (click)="saveDiscoverDetails()"
            >START DISCOVERY</button>
            <button
              mat-button mat-raised-button
              color="primary"
              *ngIf="showDiscoveryResponse"
              (click)="showDiscoverSetup()"
            >DISCOVERY SETUP</button>
            <button
              *ngIf="!savingInProgress && !showDiscoveryResponse"
              mat-button mat-raised-button
              class="plain-btn"
              (click)="onClearAllAddresses()"
            >CLEAR ALL ADDRESSES</button>
            <button
              mat-button mat-raised-button
              *ngIf="!savingInProgress"
              class="plain-btn"
              (click)="closeModal()"
            >CLOSE</button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Broadcast Discovery" *ngIf="showBroadcastTab">
        <ng-template matTabContent>
          <nrwl-broadcast-discovery [selectedEsam]="selectedEsam"></nrwl-broadcast-discovery>
        </ng-template>
      </mat-tab>
      <mat-tab label="ZTP" *ngIf="showZTPDiscovery">
        <ng-template matTabContent>
          <nrwl-zero-touch-discovery [selectedEsam]="selectedEsam"></nrwl-zero-touch-discovery>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
